export const toggleMenu = (action: 'show' | 'hide' | 'toggle') => {
  const menu = document.getElementById('menu') as HTMLElement;
  const menuPositin = getComputedStyle(menu).position;

  if (menuPositin === 'absolute') return;

  switch (action) {
    case 'show':
      menu.classList.remove('menu--hidden');
      return;

    case 'hide':
      menu.classList.add('menu--hidden');
      return;

    case 'toggle':
      menu.classList.toggle('menu--hidden');
      return;

    default:
      return;
  }
};
